module.exports = "<div class=\"panel panel-info\">\n  <div class=\"panel-heading\">ห้อง {{model.name}}</div>\n  <div class=\"panel-body\">\n    <h3>\n      <span>คิวที่:</span>\n      <span class=\"label label-success\">{{model.currentQueue}}</span>\n    </h3>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/queue-item/queue-item.component.html
// module id = 169
// module chunks = 1